"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableResponsive = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableResponsiveMixin = require("../../mixins/components/TableResponsiveMixin");
var StyledTableResponsive = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledTableResponsive",
  componentId: "c11n-8-107-0__sc-goovyt-0"
})(["", ""], _TableResponsiveMixin.TableResponsiveMixin);
exports.StyledTableResponsive = StyledTableResponsive;